import { useAppSelector } from "./useAppSelector";

export const useAuth = () => {
    const auth = useAppSelector((s) => s.auth);
    return {
        user: auth.user,
        isAuthenticated: !!auth.access_token && !!auth.user,
        isLoading: auth.status === "is_loading",
        errorMessage: auth.error_message,
        mustChangePassword: auth.must_change_password,
        passwordWeakReason: auth.password_weak_reason,
    };
};
